/*!
 i18n system
 (c) 2017-2018 Andxor soluzioni informatiche <http://www.andxor.it/>
*/
import $ from 'jquery';

var valueTags = /^(input)$/i,
    langSelect = $('#languages'),
    rev = $('#release').data('unique'),
    raw = {}, // raw translation strings
    tags = $('*[data-i18n]'); // initial set of static elements, dynamically generated ones will be added here

export function str(key, def) {
    return raw[key] || def || '[i18n: ' + key + ']';
}

function apply(idx, elem) {
    var t = str(elem.getAttribute('data-i18n'));
    if (valueTags.test(elem.tagName))
        elem.value = t;
    else
        elem.innerText = t;
}

function change(lang) {
    var url = 'i18n.js?rev=' + rev;
    if (lang)
        url += '&lang=' + lang;
    else // detect from browser headers
        delete localStorage.w2s_lang;
    $.getJSON(url, function (data) {
        raw = data;
        localStorage.w2s_lang = raw.lang;
        tags.each(apply);
    });
}

$.fn.i18n = function (key) {
    tags = tags.add(this);
    this.attr('data-i18n', key);
    return this.each(apply);
};

export function span(key) {
    var s = document.createElement('span');
    s.setAttribute('data-i18n', key);
    s.innerText = str(key);
    tags = tags.add(s);
    return s;
}

// initialization
langSelect.change(function () {
    change(langSelect.val());
});
if (localStorage.w2s_lang)
    $('#languages option[value="' + localStorage.w2s_lang + '"]').prop('selected', true);
change(localStorage.w2s_lang);
